import React, { ReactNode } from 'react'
import "./fixFooterButton.scss"

type FixFooterButtonProps = {
  children: ReactNode;
  className?: string
};

const FixFooterButton: React.FC<FixFooterButtonProps> = ({ children, className = "" }) => {
  return (
    <div className={`fix-footer-box ${className}`}>
      {children}
    </div>
  )
}

export default FixFooterButton